import { UserQueryService } from "../../../services/users/UserQueryService";
import { UserModel } from "../../models/User";
import { IQueryUserRepository } from "../../ports/user/IQueryUserRepository";
import Query from "../Query";

class UserQuery extends Query<UserModel> implements IQueryUserRepository {
  constructor(public queryService: UserQueryService) {
    super(queryService);
  }

  public async fetchCurrentUser(): Promise<UserModel | null> {
    return this.queryService.fetchCurrentUser();
  }
  public async searchByIds(ids: string[]): Promise<UserModel[]> {
    return this.queryService.searchByIds(ids);
  }
}

export default UserQuery;
